/*
 * @Version    : v1.00
 * @Author     : generated
 * @Date       : 2025-11-20
 * @desc       : 越南语 国际化语言文件
 */
// 越南语.js
export default {
  centerAgent: {
    subagency: 'Tiểu đại lý',
    search: 'Tìm kiếm',
    subagencyIncome: 'Thu nhập Tiểu đại lý',
    last29Days: '29 ngày qua',
    excludingToday: 'Không bao gồm hôm nay',
    commission: 'Hoa hồng',
    last30Days: 'Dữ liệu 30 ngày gần đây',
    rank: 'Xếp hạng',
    hostNumber: 'Số lượng Host',
    recent30Days: 'Thu nhập Host 30 ngày gần đây',
    commissionRate: 'Tỷ lệ hoa hồng',
    myCommission: 'Hoa hồng của tôi',
    remove: 'Loại bỏ',
    thisAction: 'Hành động này sẽ loại bỏ {hostoragent} {hostname} khỏi nhóm của bạn. Bạn có xác nhận muốn tiếp tục không?',
    dashboard: 'Bảng điều khiển',
    information: 'Thông tin',
    dataCenter: 'Trung tâm Dữ liệu',
    hostList: 'Danh sách Host',
    bdList: 'Danh sách BD',
    agencyList: 'Danh sách Đại lý',
    myRight: 'Quyền của tôi',
    numberOf: 'Số lượng Đại lý',
    inviteAgency: 'Mời Đại lý',
    numberOfHost: 'Số lượng Host',
    inviteHost: 'Mời chủ phòng',
    inviteHostlinkcopied: 'Đã sao chép liên kết lời mời',
    tipsShare: 'Mẹo: Chia sẻ liên kết lời mời với bạn bè của bạn',
    thisMonthD: 'Dữ liệu tháng này',
    formDay1: 'Từ day1 đến day2',
    hostGift: 'Điểm quà tặng của Host',
    agentCommission: 'Hoa hồng đại lý',
    currentLevel: 'Cấp độ hiện tại',
    commissionRateOf: 'Tỷ lệ hoa hồng thu nhập của đại lý',
    baseSalary: 'Lương cơ bản',
    stillNeed: 'Vẫn cần',
    toReach: 'để đạt được',
    reachedthe: 'Nhiệm vụ quảng cáo',
    advertisementTask: 'Tổng quan dữ liệu',
    dataOverview: 'Tổng quan dữ liệu',
    today: 'Hôm nay',
    hostPoint: 'Điểm Host',
    agentsPoints: 'Thu nhập Điểm Đại lý',
    thisMonth: 'Tháng này',
    month: 'Tháng',
    lastMonth: 'Tháng trước',
    bdNumber: 'Số lượng BD',
    hostIncome: 'Thu nhập Host',
    todayIncome: 'Thu nhập hôm nay',
    past30Days: '30 ngày qua',
    host: 'Chủ phòng',
    country: 'Quốc gia',
    level7: 'Cấp độ / Doanh thu 7 ngày',
    pointIncome: 'Thu nhập điểm',
    liveDuration: 'Thời lượng trực tiếp',
    joinTime: 'Thời gian tham gia',
    state: 'Trạng thái',
    operation: 'Thao tác',
    bd: 'BD',
    totalHosts: 'Tổng thu nhập Host',
    totalAgents: 'Tổng thu nhập đại lý',
    agent: 'Đại lý',
    agentLevel: 'Cấp độ đại lý / Tỷ lệ hoa hồng',
    commissionIncome: 'Thu nhập hoa hồng',
    showDirect: 'Chỉ hiển thị đại lý trực tiếp. Không bao gồm dữ liệu hôm nay',
    excludingTodayData: 'Không bao gồm dữ liệu hôm nay',
    packages: 'Gói dịch vụ',
    contents: 'Nội dung',
    balance: 'Số dư',
    release: 'Phát hành',
    issue: 'Phát hành',
    createBd: 'Tạo BD',
    times: 'lần',
    authorizeCs: 'Ủy quyền CS',
    giftTo: 'Tặng cho Người dùng',
    bdCreation: 'Hạn mức tạo BD còn lại',
    csAuthorization: 'Hạn mức ủy quyền CS còn lại',
    giftName: 'Tên quà tặng',
    giftContents: 'Nội dung quà tặng',
    check: 'Kiểm tra',
    cancel: 'Hủy',
    tip: 'Tiền tip',
    recipientsVip: 'Cấp VIP của người nhận vượt quá giới hạn gói quà. Các đặc quyền VIP từ quà tặng này sẽ bị vô hiệu hóa. Chắc chắn tiếp tục chứ?',
    confirm: 'Xác nhận',
    authorize: 'Ủy quyền',
    inviteBy: 'Mời theo ID Người dùng',
    invite: 'Mời',
    inviteLink: 'Liên kết mời',
    copy: 'Sao chép',
    success: 'Thành công',
    pleaseCheck: 'Vui lòng kiểm tra ID người dùng',
    totalGift: 'Tổng thu nhập quà tặng của tất cả Host (không bao gồm phần thưởng nền tảng như xếp hạng, nhiệm vụ, v.v.), bao gồm thu nhập quà tặng của đại lý cấp dưới.',
    totalAgentsCom: 'Tổng hoa hồng của đại lý từ thu nhập host của họ, bao gồm hoa hồng của đại lý cấp dưới.',
    allAgent: 'Tất cả đại lý',
    directAgent: 'Đại lý trực tiếp',
    indirectAgent: 'Đại lý gián tiếp',
    newUpgraded: 'Đại lý mới được nâng cấp',
    newS: 'Đại lý cấp S mới',
    newB: 'Đại lý cấp B mới',
    newC: 'Đại lý cấp C mới',
    expectedReward: 'Phần thưởng dự kiến',
    newA: 'Đại lý cấp A mới',
    agencyLevel: 'Cấp độ đại lý',
    nickname: 'Biệt danh',
    upgradeDate: 'Ngày nâng cấp',
    bdPolicy: 'Chính sách BD',
    agencyDetail: 'Chi tiết đại lý',
    agency: 'Đại lý',
    hostCommission: 'Hoa hồng Host',
    last6Days: '6 ngày qua',
    giftIncome: 'Thu nhập quà tặng',
    mins: 'phút',
    agencyCenter: 'Trung tâm đại lý',
    myIncome: 'Thu nhập hôm nay của tôi',
    totalHost: 'Tổng điểm Host',
    overview: 'Tổng quan',
    hostPoints: 'Điểm Host',
    myHosts: 'Điểm Host của tôi',
    subagentHost: 'Điểm Host của đại lý cấp dưới',
    subagencyNumber: 'Số lượng đại lý cấp dưới',
    otherIncome: 'Thu nhập khác',
    contactAdmin: 'Liên hệ Quản trị viên',
    whatsapp: 'WhatsApp',
    bdCenter: 'Trung tâm BD',
    copySuccess: 'Sao chép thành công',
    pleaseInput: 'Vui lòng nhập số tiền nạp, tối thiểu 10',
    agencyPolicy: 'Chính sách đại lý',
    agencyCommission: 'Hoa hồng đại lý',
    agencyCommission2: 'Hoa hồng đại lý = Tỷ lệ hoa hồng × Tổng thu nhập quà tặng của tất cả Host (không bao gồm phần thưởng nền tảng như xếp hạng, nhiệm vụ, v.v.)',
    excludingPlatform: '(không bao gồm phần thưởng nền tảng như xếp hạng, nhiệm vụ, v.v.)',
    agencyCommissionCalculation: 'Tính hoa hồng đại lý',
    level: 'Mức độ',
    pointsTarget: 'Mục tiêu điểm (30 ngày qua)',
    points10000: '10,000 Điểm = 1 USD (M= triệu)',
    note1: 'Ghi chú 1: Tổng thu nhập hợp lệ = Thu nhập đại lý của bạn + Thu nhập của từng cấp đại lý cấp dưới của bạn',
    note2: 'Ghi chú 2: Hoa hồng đại lý sẽ được cộng vào thời gian thực khi Host nhận được quà tặng.',
    note3: 'Ghi chú 3: Số tiền rút tối thiểu là 10 USD và số tiền rút phải là bội số của 10 (ví dụ: 10 USD, 20 USD, 30 USD).',
    subagencycommission: 'Hoa hồng đại lý cấp dưới',
    theMain: 'Đại lý chính có thể kiếm được hoa hồng từ thu nhập của từng cấp đại lý phụ (T1, T2, T3, T4, ... Tn), với tỷ lệ hoa hồng tối đa là 16%.',
    forExample: 'Ví dụ:',
    agencyA: 'Đại lý A mời Đại lý B và Đại lý C.',
    agencyB: 'Đại lý B mời Đại lý D và Đại lý E.',
    agencyC: 'Đại lý C mời Đại lý F.',
    noteFigures: '(Lưu ý: số trong ngoặc đơn thể hiện thu nhập của các host thuộc mỗi đại lý).',
    thusWe: 'Do đó, chúng ta có thể tính Tổng Thu nhập Hợp lệ và Tỷ lệ Hoa hồng của các đại lý từ Đại lý A đến Đại lý F.',
    totalValid: 'Tổng Thu nhập Hợp lệ = Thu nhập Đại lý của Bạn + Thu nhập của Mỗi Cấp Đại lý Phụ',
    aTotal: 'A Tổng Thu nhập Hợp lệ = A + B + C + D + E + F = 10M + 20M + 70M + 20M + 30M +80M = 230M (tỷ lệ hoa hồng 20%)',
    bTotal: 'B Tổng Thu nhập Hợp lệ = B + D + E = 20M + 20M + 30M = 70M (tỷ lệ hoa hồng 16%)',
    cTotal: 'C Tổng Thu nhập Hợp lệ = C + F = 70M + 80M =150M (tỷ lệ hoa hồng 20%)',
    dTotal: 'D Tổng Thu nhập Hợp lệ =20M (tỷ lệ hoa hồng 12%)',
    eTotal: 'E Tổng Thu nhập Hợp lệ =30M (tỷ lệ hoa hồng 12%)',
    fTotal: 'F Tổng Thu nhập Hợp lệ =80M (tỷ lệ hoa hồng 16%)',
    subagencyCommission: 'Hoa hồng đại lý phụ = (Tỷ lệ hoa hồng đại lý chính - Tỷ lệ hoa hồng đại lý phụ) × Tổng thu nhập hợp lệ của đại lý phụ',
    agencyAC: 'Hoa hồng Đại lý {A} nhận được từ Đại lý {B}',
    thereforeAgency: 'Do đó, tổng hoa hồng Đại lý {A} nhận được từ các đại lý phụ',
    sinceAgency: 'Vì Đại lý D, E và F không có đại lý phụ nên họ không thể kiếm được hoa hồng từ đại lý phụ。',
    seniorPolicy: 'Chính sách Cấp cao',
    nomore: 'Không còn dữ liệu',
    active: 'Đang hoạt động',
    disabled: 'Đã vô hiệu hóa',
    deleted: 'Đã xóa',
    lastLogintime: 'Thời gian đăng nhập cuối',
    onmic: 'Lên mic hôm nay'
  },
  sellerCoin: {
    detailsOf: 'Chi tiết rút tiền',
    fundsSent: 'Đã gửi tiền',
    transfer: 'Chuyển khoản',
    totalIncome: 'Tổng thu nhập',
    orderIncome: 'Thu nhập đơn hàng',
    estimatedReward: 'Phần thưởng ước tính',
    amount: 'Số tiền',
    applicantId: 'ID Người nộp đơn',
    applicantName: 'Tên Người nộp đơn',
    orderId: 'ID đơn hàng',
    uploadScreenshot: 'Tải lên ảnh chụp màn hình',
    ensureWithdrawal: 'Đảm bảo rút tiền thành công, sau đó tải lên ảnh chụp màn hình và nhấp vào nút bên dưới để thông báo cho người nộp đơn.',
    remain: 'Còn lại',
    pleasePay: 'Vui lòng thanh toán ngay lập tức và tải lên biên lai. Nếu vượt quá thời hạn, tư cách thanh toán của đơn hàng sẽ bị hủy bỏ.',
    youCan: 'Bạn có thể kiếm được tới 5.000 điểm mời mỗi ngày',
    pleaseComplete: 'Vui lòng hoàn tất việc rút tiền đúng thời gian ',
    unableTo: 'Không thể thanh toán, Từ chối',
    notifyThe: 'Thông báo cho người nộp đơn',
    youCanGet: 'Xử lý đơn hàng kịp thời, bạn có thể nhận thêm 1%-3% tiền thưởng.',
    ifYou: 'Nếu bạn xử lý đơn hàng trong vòng 30 phút, bạn có thể nhận thưởng 3%.',
    egThe: 'Ví dụ: Đơn hàng trị giá 90000 điểm, bạn xử lý trong vòng 30 phút, có thể nhận thưởng 3%, tức là 90000 × 3% = 2700 điểm.',
    gotIt: 'Đã hiểu',
    pleaseUpload: 'Vui lòng tải lên hình ảnh',
    detail: 'Chi tiết',
    balance: 'Balance',
    exchange: 'Trao đổi',
    all: 'Tất cả',
    recharge: 'Nạp tiền',
    official: 'Chính thức',
    exchangeDetail: 'Chi tiết giao dịch',
    coinSeller: 'Người bán xu',
    levelUp: 'Nâng cấp',
    currentLevel: 'Current level',
    myBalance: 'Số dư của tôi',
    details: 'Chi tiết',
    paymentMethod: 'Phương thức thanh toán',
    myOrder: 'Đơn hàng của tôi',
    paymentMenthod: 'Phương thức thanh toán',
    acceptingOrders: 'Đang nhận đơn',
    unavailable: 'Không khả dụng',
    greetingMessage: 'Cài đặt tin nhắn chào mừng',
    serviceUnavailable: 'Dịch vụ không khả dụng',
    thisFeature: 'Tính năng này tạm thời bị khóa. Vui lòng liên hệ với bộ phận hỗ trợ khách hàng để được trợ giúp.',
    editMessage: 'Chỉnh sửa tin nhắn',
    customizeYour: 'Tùy chỉnh tin nhắn chào mừng của bạn. Bạn có thể bao gồm thông tin hữu ích về việc nạp tiền xu.',
    theMessage: 'Tin nhắn sẽ được tự động gửi khi người dùng mới bắt đầu trò chuyện riêng tư với bạn',
    save: 'Lưu',
    pleaseEnterMessge: 'Vui lòng nhập tin nhắn chào mừng của bạn',
    salesMethod: 'Phương thức bán hàng',
    user: 'Người dùng',
    coinseller: 'Người bán xu',
    userId: 'ID người dùng',
    check: 'Check',
    coinAmount: 'Số lượng xu',
    pleaseEnter: 'Vui lòng nhập bội số của 1',
    enterAt: 'Nhập ít nhất 100, theo bội số của 1',
    transferDetails: 'Chi tiết chuyển khoản',
    recommendSeller: 'Đề xuất người bán',
    recent30Day: 'Doanh số bán xu 30 ngày gần đây',
    whatsapp: 'WhatsApp',
    chat: 'Trò chuyện',
    yourCountry: 'Quốc gia của bạn hiện không có người bán xu nào.',
    pleaseContact: 'Vui lòng liên hệ với bộ phận hỗ trợ khách hàng.',
    customerSupport: 'hỗ trợ khách hàng',
    contact: 'Liên hệ',
    customRecharge: 'Nạp tiền tùy chỉnh',
    rechargeDetails: 'Chi tiết nạp tiền',
    myPoints: 'Điểm của tôi',
    todayRemaining: 'Hạn ngạch còn lại hôm nay',
    customExchange: 'Trao đổi tùy chỉnh',
    exchangeDetails: 'Chi tiết trao đổi',
    rechargeRules: 'Quy tắc nạp tiền',
    sellerLevel: 'Cấp độ người bán',
    proportion: 'Tỷ lệ',
    levelRequirement: 'Yêu cầu cấp độ',
    beginner: 'Người mới bắt đầu',
    singleRecharge: 'Nạp tiền một lần',
    standard: 'Tiêu chuẩn',
    senior: 'Cao cấp',
    exchangeRules: 'Quy tắc trao đổi',
    note: 'Note',
    seniorCoin: 'Người bán xu cao cấp nhận được {point} điểm miễn phí mỗi ngày. Thêm tại ',
    beginnerSeller: 'Người bán mới bắt đầu',
    standardSeller: 'Người bán tiêu chuẩn',
    seniorSeller: 'Người bán cao cấp',
    cancel: 'Cancel',
    pleaseInput: 'Please input the recharge amount, minimum 10',
    pleaseInput2: 'Vui lòng nhập số tiền nạp, bội số của 100K',
    confirmation: 'Xác nhận',
    userName: 'Tên người dùng',
    theUser: 'Người dùng đã bị đưa vào danh sách đen',
    enterAmount: 'Nhập số tiền',
    pleaseInput3: 'Vui lòng nhập số tiền',
    theAmount: 'Số tiền phải là bội số của 100000',
    pleaseInput4: 'Vui lòng nhập hoặc chọn số tiền',
    pleaseSelect: 'Vui lòng chọn phương thức bán hàng',
    pleaseInput5: 'Vui lòng nhập ID người dùng',
    atLeast: 'Ít nhất 100K xu để chuyển~',
    pleaseSelect2: 'Vui lòng chọn phương thức thanh toán',
    minimum: 'tối thiểu',
    theAmount3: 'Số tiền phải là bội số của 1',
    lessThan: 'nhỏ hơn hoặc bằng 100000',
    orders: 'Đơn hàng',
    applicant: 'Người nộp đơn',
    method: 'Phương pháp',
    withdrawTime: 'Thời gian rút tiền',
    viewDetail: 'Xem chi tiết',
    toBe: 'Chờ xác nhận',
    toBePaid: 'Chờ thanh toán',
    toBeCompleted: 'Chờ hoàn thành',
    completed: 'Đã hoàn thành',
    abnormal: 'Bất thường',
    refused: 'Refused',
    confirmationTimeout: 'Hết thời gian xác nhận',
    paymentTimeout: 'Hết thời gian thanh toán',
    binance: 'Binance',
    scanThe: 'Quét mã QR để thanh toán',
    quantity: 'Số lượng',
    orderAmount: 'Số tiền đơn hàng',
    date: 'Ngày',
    payNow: 'Thanh toán ngay',
    payment: 'Thanh toán',
    pleasePay2: 'Vui lòng thanh toán theo cách sau',
    chainName: 'Tên chuỗi',
    contractAddress: 'Địa chỉ hợp đồng',
    theAbove: 'Địa chỉ trên chỉ có hiệu lực cho lần nạp tiền này',
    copy: 'Copy',
    notice: 'Thông báo',
    pleaseTransfer: 'Vui lòng chuyển thêm 1 USDT để trang trải phí Binance. Không làm như vậy có thể trì hoãn việc nạp xu của bạn.',
    paymentsMust: 'Thanh toán phải được hoàn thành trong vòng 0,5 giờ, nếu không nền tảng sẽ không chịu trách nhiệm cho bất kỳ vấn đề nào.',
    add: 'Thêm',
    confirmTo: 'Xác nhận xóa phương thức thanh toán này',
    countryCurrency: 'Quốc gia & Loại tiền tệ',
    selectPayment: 'Chọn phương thức thanh toán mà bạn có thể chuyển tiền',
    coinsSeller: 'Quy tắc người bán xu',
    standrd: 'Tiêu chuẩn',
    salesMethods: 'Phương thức bán hàng',
    coinsellerRules: 'Quy tắc người bán xu',
    whenApplying: 'Khi nộp đơn nâng cấp lên trạng thái người bán xu, không yêu cầu tiền gửi, chỉ cần nạp tiền 1 lần để nâng cấp cấp độ người bán xu. Nếu bạn chọn từ chức vị trí người bán xu, vai trò người bán xu hiện tại của bạn sẽ hết hạn',
    youCanReplenish: 'Bạn có thể nạp tiền vào tài khoản của mình trực tiếp bằng USDT, Epay hoặc thông qua một người bán xu khác',
    fraudulentActivities: 'Các hoạt động gian lận bị nghiêm cấm trong nền tảng Hala.',
    anyViolations: 'Mọi vi phạm sẽ dẫn đến việc chấm dứt tài khoản của người bán xu',
    allRights: 'Mọi quyền được bảo lưu bởi Hala.',
    transferDetail: 'Chi tiết chuyển khoản'
  },
  centerHost: {
    baseSalary: 'Base Salary',
    invitation: 'Lời mời',
    tasks: 'Nhiệm vụ',
    other: 'Khác',
    consume: 'Tiêu thụ',
    giftIncome: 'Gift Income',
    received: 'Đã nhận',
    from: 'từ',
    luckyGift: 'Quà may mắn',
    hostCenter: 'Trung tâm chủ phòng',
    noAgent: 'Không có đại lý',
    last7: '7 ngày qua',
    hourlyIncome: 'Thu nhập theo giờ',
    toReach: 'to reach',
    rules: 'Quy tắc',
    pointsOverview: 'Tổng quan điểm',
    totalIncome: 'Total Income',
    gifts: 'quà tặng',
    workDetail: 'Chi tiết công việc',
    liveDuration: 'Live Duration',
    mins: 'mins',
    todaysLive: 'Bản ghi trực tiếp hôm nay',
    dailyStatistics: 'Thống kê hàng ngày',
    startTime: 'Thời gian bắt đầu',
    endTime: 'Thời gian kết thúc',
    duration: 'Thời lượng',
    points: 'Điểm',
    date: 'Date',
    giftPoints: 'Điểm quà tặng',
    removeBinding: 'Gỡ liên kết',
    thisAction2: 'Hành động này sẽ hủy liên kết bạn khỏi {agentName}. Vui lòng xác nhận nếu bạn muốn tiếp tục hủy liên kết'
  },
  bombRule: {
    afterThe: 'Sau khi giá trị kích nổ trong phòng đạt đến một lượng nhất định, quả bom quà tặng sẽ xuất hiện trong phòng',
    oneCoins: '1 xu nhận được trong phòng = 1 giá trị kích nổ',
    itWill: 'Nó sẽ tự động phát nổ sau khi đáp ứng các yêu cầu và chủ phòng sẽ nhận được phần thưởng xu vàng tương ứng'
  },
  descriptionLevel: {
    wealth: 'Sự giàu có',
    charm: 'Sức hút',
    wealthValue: 'Giá trị sự giàu có',
    charmValue: 'Giá trị sức hút',
    needTo: 'Cần',
    send: 'gửi',
    receive: 'nhận',
    forThe: 'để nâng cấp',
    theRich: 'Cấp độ Giàu có được tính bằng số xu bạn đã nạp',
    theCharm: 'Cấp độ Sức hút được tính dựa trên số xu bạn nhận được',
    LevelLabel: 'Nhãn cấp độ',
    level: 'Level',
    levelLogo: 'Biểu tượng cấp độ'
  },
  gameRank: {
    gameRank: 'Xếp hạng trò chơi',
    rules: 'Rules',
    thisWeek: 'Tuần này',
    lastWeek: 'Tuần trước',
    agentGaming: 'Xếp hạng doanh thu trò chơi đại lý',
    rankingRewards: 'Phần thưởng xếp hạng',
    rankingIs: 'Xếp hạng dựa trên tổng doanh thu cược của người dùng trong phòng đại lý và các phòng con của nó.',
    hostRoom: 'Xếp hạng doanh thu phòng chủ',
    rankingIs2: 'Xếp hạng dựa trên tổng doanh thu trò chơi được tạo ra trong phòng của chủ phòng',
    notes: 'Ghi chú',
    eventDuration: 'Thời gian sự kiện: Mỗi tuần lịch. Phần thưởng chỉ được phân phối nếu',
    rewardsAre: 'Rewards are distributed only if the corresponding revenue requirements are met.',
    allRewards: 'All rewards will be issued within 1-2 working days after the event ends.',
    halaReserves: 'Hala bảo lưu quyền giải thích cuối cùng cho sự kiện này',
    rewardsDetail: 'Chi tiết phần thưởng',
    decorationsPreview: 'Xem trước trang trí'
  },
  gameLegacyHall: {
    surpriseLucky: 'Túi may mắn bất ngờ',
    dailyPlayers: 'Người chơi hàng ngày có thể mở Túi may mắn vào ngày hôm sau để nhận xu ngẫu nhiên',
    eventRule: 'Quy tắc sự kiện',
    usersSpending: 'Chi tiêu của người dùng trong trò chơi sự kiện sẽ được tính vào điểm xếp hạng của họ',
    thePlatform: 'Nền tảng sẽ luân phiên các trò chơi sự kiện mỗi 4 giờ, với 4 trò chơi khác nhau được đặc trưng trong mỗi lần luân phiên',
    theTop: '3 người chơi hàng ngày hàng đầu sẽ nhận được khung hình và phần thưởng xu',
    theTop2: '10 người chơi hàng tuần hàng đầu sẽ nhận được khung hình và phần thưởng xu',
    usersWho: 'Người dùng tham gia trò chơi sự kiện mỗi ngày có thể mở túi may mắn vào ngày hôm sau để nhận số xu ngẫu nhiên. Bạn càng chi tiêu nhiều trong trò chơi sự kiện, bạn càng có thể nhận được nhiều xu',
    behindPrevious: 'Đằng sau trước đó',
    thisWeek: 'This Week',
    lastWeek: 'Last Week',
    countdown: 'Đếm ngược:',
    days: 'ngày',
    winOver: 'Thắng hơn',
    coinsfrom: 'xu từ trò chơi trong một ngày',
    earnOver: 'Kiếm được hơn',
    coinsWitdh: 'với tỷ lệ hoàn trả lên đến',
    fromOneDay: 'từ một ngày trong',
    game: 'Trò chơi',
    fromA: 'từ một cược duy nhất trong',
    inthisWeek: 'Trong tuần này',
    earnUp: 'Kiếm được tới',
    inAsingle: 'trong một ngày',
    eventRules: 'Quy tắc sự kiện',
    participateIn: 'Tham gia trò chơi để nhận túi may mắn lớn hơn vào ngày mai',
    youDid: 'Bạn đã không nhận được phần thưởng xu. Tham gia trò chơi và bạn có thể tiếp tục nhận túi may mắn vào ngày mai',
    participateIn2: 'Tham gia trò chơi và bạn có thể tiếp tục nhận túi may mắn vào ngày mai',
    topDaily: 'Người chiến thắng xu hàng ngày hàng đầu',
    topPayout: 'Người chiến thắng tỷ lệ trả thưởng hàng đầu',
    topCoins: 'Người chiến thắng xu hàng đầu trong một vòng hàng tuần',
    topPayout2: 'Người chiến thắng tỷ lệ trả thưởng hàng đầu trong một vòng hàng tuần',
    topWeekly: 'Người chiến thắng xu hàng tuần hàng đầu',
    historicalTop: 'Người chiến thắng xu hàng đầu trong lịch sử trong một ngày',
    historicalTop2: 'Người chiến thắng tỷ lệ trả thưởng hàng đầu trong lịch sử trong một ngày',
    historicalTop3: 'Người chiến thắng xu hàng đầu trong lịch sử trong một vòng',
    historicalTop4: 'Người chiến thắng tỷ lệ trả thưởng hàng đầu trong lịch sử trong một vòng',
    historicalTop5: 'Người chiến thắng xu hàng đầu trong lịch sử trong một tuần',
    gameReward: 'Phần thưởng trò chơi',
    usersSpending2: 'Chi tiêu của người dùng trong trò chơi sự kiện sẽ được tính vào điểm xếp hạng của họ',
    theTop3: '3 người chơi hàng ngày hàng đầu sẽ nhận được khung hình và phần thưởng xu',
    theTop4: '10 người chơi hàng tuần hàng đầu sẽ nhận được khung hình và phần thưởng xu',
    usersWho2: 'Người dùng tham gia trò chơi sự kiện mỗi ngày có thể mở túi may mắn vào ngày hôm sau để nhận số xu ngẫu nhiên. Bạn càng chi tiêu nhiều trong trò chơi sự kiện, bạn càng có thể nhận được nhiều xu',
    coins: 'Tiền xu',
    flameRider: 'Kỵ sĩ lửa',
    sportCar: 'Xe thể thao',
    captainMeow: 'Đội trưởng Meo',
    profileFrame: 'Khung Hồ Sơ'
  },
  gold: {
    coinsDetail: 'Chi tiết xu',
    coinBalance: 'Số dư xu',
    all: 'ALL',
    sendGifts: 'Gửi quà tặng',
    purchaseItems: 'Mua vật phẩm',
    games: 'Trò chơi',
    exchange: 'Exchange',
    recharge: 'Recharge',
    activeReword: 'Phần thưởng hoạt động',
  },
  integral: {
    all: 'All',
    cashOut: 'Rút tiền',
    transfer: 'Transfer',
    orderId: 'Order ID',
    paymentMenthod: 'Payment Menthod',
    withdrawalTime: 'Thời gian rút tiền',
    pointsAmount: 'Số điểm',
    depositAmount: 'Số tiền gửi',
    coinsAmount: 'Số lượng xu',
    transferTo: 'Chuyển đến',
    normal: 'Bình thường',
    pending: 'Đang chờ',
    success: 'Success',
    failed: 'Thất bại',
    points: 'Points',
    pointsBalance: 'Số dư điểm',
    frozenPoints: 'Điểm bị đóng băng',
    details: 'Details',
    exchange: 'Exchange',
    currencyType: 'Loại tiền tệ',
    paymentMethod: 'Payment method',
    pointsAmount2: 'Số điểm để rút tiền',
    enterA: 'Nhập bội số của 100,000 (tối thiểu 200,000)',
    enterA2: 'Nhập bội số của 100000',
    accountInformation: 'Thông tin tài khoản',
    withdraw: 'Rút tiền',
    amount: 'Amount',
    exchangeRate: 'Tỷ giá hối đoái',
    exchangePoints: 'Điểm trao đổi',
    enterUserId: 'Nhập ID người dùng',
    check: 'Check',
    fee: 'Phí',
    theAgency: 'Đại lý sẽ nhận',
    transferFee: 'Phí chuyển khoản: 2%. Chuyển khoản tối thiểu ≥ 100,000 điểm.',
    clickTransfer: 'Nhấp vào nút chuyển khoản để chuyển điểm tương ứng cho đại lý của bạn',
    afterThe2: 'Sau khi chuyển khoản hoàn tất, không thể hủy bỏ hoặc rút tiền',
    transferPoints: 'Chuyển điểm',
    recommendedMethod: 'Phương pháp được đề xuất',
    lowerFees: 'Phí thấp hơn và được xem xét trong vòng 24 giờ',
    paymentPassword: 'Mật khẩu thanh toán chưa được đặt',
    cashOut2: 'Rút tiền và Trao đổi yêu cầu xác minh mật khẩu thanh toán. Vui lòng thiết lập mật khẩu thanh toán của bạn trước.',
    cancel: 'Cancel',
    goTo: 'Đi đến Cài đặt',
    youHave: 'Bạn đã đạt 5 lần thử không thành công. Thêm một lần thử không thành công nữa sẽ dẫn đến việc tài khoản bị đóng băng. Nếu quên mật khẩu, vui lòng đặt lại.',
    inputIncorrect: 'Đã nhập sai mật khẩu nhiều lần. Tài khoản của bạn đã bị đóng băng, vui lòng thử lại sau',
    verify: 'xác minh',
    gotIt: 'Got it',
    pointsInfo: 'Thông tin điểm',
    whenA: 'Khi người dùng gửi quà tặng cho bạn bằng Xu được nạp qua Google, điểm bạn nhận được sẽ bị đóng băng trong 7 ngày trước khi có sẵn. Nếu người dùng yêu cầu hoàn tiền, những điểm đó sẽ bị khấu trừ. Vui lòng tuân theo quy tắc nền tảng và tránh mọi vi phạm.',
    frozenPointsAre: 'Điểm bị đóng băng được bao gồm trong tổng số dư điểm',
    theUser2: 'Người dùng đã bị đưa vào danh sách đen',
    successfulWithdrawal: 'Rút tiền thành công',
    withdrawalAmount: 'Số tiền rút',
    theFunds: 'Tiền sẽ đến trong vòng 24 giờ',
    pleaseEnter2: 'Vui lòng nhập mật khẩu',
    passwordIncorrect: 'Mật khẩu không đúng',
    theAmount4: 'Số tiền phải là bội số của 100000',
    pleaseEnter3: 'Vui lòng nhập ID người dùng',
    pleaseEnter4: 'Vui lòng nhập ID người dùng chính xác',
    pleaseEnter5: 'Vui lòng nhập số tiền',
    minimumTransfer: 'Chuyển khoản tối thiểu ≥ 100,000 điểm',
    pleaseSelect3: 'Vui lòng chọn phương pháp',
    minimum: 'minimum',
    theAmount5: 'Số tiền phải nhỏ hơn',
    illegalInput: 'Đầu vào không hợp lệ',
    pleaseEnter6: 'Vui lòng nhập thông tin tài khoản'
  },
  invite: {
    inviteGame: 'Mời người dùng trò chơi',
    currentRebate: 'Hoàn trả hiện tại',
    need: 'cần',
    toProgress: 'để tiến triển đến cấp độ tiếp theo',
    gameReward: 'Game Reward',
    referralData: 'Dữ liệu giới thiệu',
    referralList: 'Danh sách giới thiệu',
    date: 'Date',
    gameBets: 'Cược trò chơi',
    inviteRewards: 'Phần thưởng mời',
    viewMore: 'Xem thêm',
    inviteFriends: 'Mời bạn bè',
    myReward: 'Phần thưởng của tôi',
    totalRewards: 'Tổng phần thưởng',
    dailyReward: 'Phần thưởng hàng ngày',
    inviteRules: 'Quy tắc mời',
    yourRebate: 'Tỷ lệ hoàn trả của bạn phụ thuộc vào Tổng số cược hợp lệ của bạn trong 30 ngày qua',
    totalValid2: 'Tổng cược hợp lệ = Cược tự đặt của bạn + Cược tự đặt của mỗi cấp người dùng được bạn mời',
    rebateFrom: 'Hoàn trả từ người dùng mời Cấp 1 = Cược tự đặt của họ × Tỷ lệ hoàn trả của bạn',
    rebateFrom2: 'Hoàn trả từ người dùng mời Cấp 2 = Cược tự đặt của họ × (Tỷ lệ hoàn trả của bạn - Tỷ lệ hoàn trả Cấp 1)',
    ifThe: 'Nếu người dùng mời Cấp 2 mời người dùng Cấp 3, nó có thể tăng Tổng cược hợp lệ của họ, nhưng họ không thể nhận hoàn trả từ Cấp 3.',
    example: 'Ví dụ',
    tier1: 'Cấp 1 được mời - Làm thế nào để tính hoàn trả từ những người được bạn mời trực tiếp?',
    asRebate: 'Hoàn trả của A từ B, C và D = (Cược tự đặt của B + Cược tự đặt của C + Cược tự đặt của D) × Tỷ lệ hoàn trả của A =',
    bsRebate: 'Hoàn trả của B từ E và F = (Cược tự đặt của E + Cược tự đặt của F) × Tỷ lệ hoàn trả của B =',
    csRebate: 'Hoàn trả của C từ G = Cược tự đặt của G × Tỷ lệ hoàn trả của C =',
    tier2: 'Cấp 2 được mời - Làm thế nào để tính hoàn trả từ những người được bạn mời gián tiếp?',
    asRebate2: 'Hoàn trả của A từ E và F = (Tỷ lệ hoàn trả của A - Tỷ lệ hoàn trả của B) × (Cược tự đặt của E + Cược tự đặt của F) =',
    asRebate3: 'Hoàn trả của A từ G = (Tỷ lệ hoàn trả của A - Tỷ lệ hoàn trả của C) × Cược tự đặt của G =',
    myInvitation: 'Lời mời của tôi',
    search: 'Search',
    invitationTime: 'Thời gian mời',
    inviteHost: 'Invite Host',
    inviteA: 'Mời một chủ phòng, Mỗi người tối đa',
    todayRewards: 'Phần thưởng hôm nay',
    rewardDetail: 'Chi tiết phần thưởng',
    creatorRewards: 'Ví phần thưởng nhà sáng tạo',
    collect: 'Thu thập',
    invitationDate: 'Ngày mời',
    hostPolicy: 'Chính sách chủ phòng',
    halaReserves2: 'Hala bảo lưu quyền giải thích cuối cùng đối với các chính sách trên.'
  },
  listContribution: {
    contributiont: 'Đóng góp',
    host: 'Host',
    wealth: 'Wealth',
    today: 'Today',
    yesterday: 'Hôm qua',
    game: 'Game',
    gift: 'Quà',
    hostEarnings: 'Thu nhập chủ phòng'
  },
  missionRule: {
    hostPolicy: 'Host Policy',
    halaReserves3: 'Hala bảo lưu quyền giải thích cuối cùng đối với các chính sách trên'
  },
  purchase: {
    recharge: 'Recharge',
    userId: 'User ID',
    confirm: 'Confirm',
    switchAccount: 'Chuyển đổi tài khoản',
    countryRegion: 'Quốc gia/Vùng',
    officialAgency: 'Nạp tiền đại lý chính thức',
    ttOff: 'Giảm 20%',
    totalAmount: 'Tổng số tiền',
    purchase: 'Mua',
    pleaseComfirm: 'vui lòng xác nhận ID người dùng',
    pleaseInput8: 'Vui lòng nhập ID người dùng',
    onlineService: 'Dịch vụ trực tuyến',
    dealOf: 'Giao dịch 30 ngày qua',
    recent30Day2: 'Doanh số bán xu 30 ngày gần đây',
    paymentMethod: 'Payment Method',
    whatsapp: 'WhatsApp',
    chat: 'Chat',
    yourCountry2: 'Quốc gia của bạn hiện không có người bán xu nào',
    pleaseContact2: 'Vui lòng liên hệ với bộ phận hỗ trợ khách hàng.',
    customerSupport: 'customer support',
    contact: 'Contact'
  },
  roomGiftRule: {
    eventRules: 'Event Rules',
    treasureChest: 'Tiến trình rương kho báu được tăng bằng cách tặng quà trong phòng',
    whenThe: 'Khi thanh tiến trình chìa khóa rương đầy, rương kho báu sẽ được mở',
    afterThe3: '.Sau khi rương kho báu cấp 3 và cấp 4 đáp ứng yêu cầu, chúng sẽ bị khóa trong 1 phút và sau đó tự động mở',
    everyoneIn: 'Mọi người trong phòng đều có cơ hội nhận được phần thưởng trong rương kho báu',
    onceThe: 'Sau khi mở rương kho báu, hệ thống có thể mất vài phút để gửi phần thưởng vào tài khoản của bạn. Tiền vàng sẽ được cộng vào số dư và trang phục sẽ được thêm vào kho đồ của bạn.',
    theHigher: 'Cấp độ của rương kho báu càng cao thì phần thưởng trong đó càng lớn',
    ifYou2: 'Nếu bạn được chọn làm VIP với cấp độ VIP thấp hơn cấp độ VIP hiện tại của bạn, cấp độ VIP sẽ không có hiệu lực',
    theProgress: 'Thanh tiến trình của chìa khóa rương sẽ được đặt lại vào lúc 00:00 (UTC+5:30) hàng ngày'
  },
  share: {
    joinHala: 'Tham gia Hala để mở khóa nhiều cơ hội kiếm tiền và tận hưởng các lợi ích và phần thưởng dành riêng cho các Đại lý.',
    downloadTo: 'Tải xuống để trở thành đối tác',
    joinHala2: 'Tham gia Hala để chơi những trò chơi thú vị và có cơ hội giành được những giải thưởng hấp dẫn.',
    downloadAnd: 'Tải xuống và bắt đầu chiến thắng',
    joinHala3: 'Tham gia Hala và bắt đầu hành trình hosting của bạn. Nhận tiền thưởng hàng ngày lên đến 36 đô la!',
    inviteYou: 'Mời bạn tham gia Agency',
    downloadNow: 'Tải xuống ngay để bắt đầu lưu trữ',
    comeWith: 'Hãy cùng tôi tham gia phòng chat tại Hala',
    enthusiastsFrom: 'những người đam mê từ khắp nơi trên thế giới cùng nhau chia sẻ...',
    igniteEndless: 'Khơi dậy niềm vui bất tận',
    download: 'Tải xuống',
    halaLive: 'Hala Live',
    showMe: 'Cho tôi thấy thế giới hạnh phúc',
    saySomething: 'Hãy nói gì đó đi...',
    downloadHala: 'Tải ứng dụng Hala'
  },
  starHost: {
    starHost: 'Ngôi sao chủ nhà',
    level2: 'Mức {level} được duy trì trong {days} ngày',
    currentSalary: 'Mức lương hiện tại',
    points: 'Points',
    likes: 'Thích',
    stillNeed: 'Still need',
    done: 'Xong',
    numberOf2: 'Số lượng người tặng quà',
    gifters: 'Người tặng quà',
    gcoinGifts: 'Quà tặng Gcoin',
    gifts: 'gifts',
    liveDuration: 'Live Duration',
    min: 'phút',
    completeAll: 'Hoàn thành tất cả các nhiệm vụ sau để nâng cấp',
    follower: 'Người theo dõi',
    numberOf3: 'Số lượng người tặng quà',
    daysAt: 'Những ngày ở cấp độ {level}',
    giftCollection: 'Bộ sưu tập quà tặng',
    gift: 'Gift',
    date: 'Date',
    expectedSalary: 'Mức lương mong đợi',
    gcoin: 'Gcoin',
    status: 'Trạng thái',
    levelReached: ' Đã đạt đến cấp độ',
    notAchieved: 'Không đạt được',
    starHost2: 'Quy tắc của người dẫn chương trình ngôi sao',
    eachStar: 'Mỗi Star Host có thời gian dùng thử 3 ngày',
    theyWill: 'Họ sẽ chỉ trở thành Người dẫn chương trình chính thức nếu họ đạt tiêu chuẩn trình độ A trong cả 3 ngày',
    thoseWho: 'Những người không đạt được mục tiêu A-level hàng ngày sẽ bị sa thải',
    firedHosts: 'Người dẫn chương trình bị sa thải không thể kiếm được mức lương cơ bản của Người dẫn chương trình ngôi sao',
    starHost3: 'Lương cơ bản của Star Host được trả hàng tuần, vào mỗi thứ Hai',
    ifA: 'Nếu một Người dẫn chương trình ngôi sao không hoàn thành nhiệm vụ hàng ngày, họ sẽ chỉ nhận được 50% lương theo giờ',
    selfGifting: 'Việc tự tặng quà bị nghiêm cấm đối với tất cả các mục tiêu tặng quà',
    starHost4: 'Phần thưởng dành cho chủ nhà ngôi sao ở nhiều cấp độ khác nhau',
    level: 'Level',
    dailyExtra: 'Phần thưởng điểm thưởng hàng ngày',
    liveBroadcast: 'Thời gian phát sóng trực tiếp cần thiết',
    starHost5: 'Yêu cầu của Chủ nhà Ngôi sao cho các cấp độ khác nhau',
    requirements: 'Yêu cầu',
    yourApplication: 'Đơn đăng ký của bạn đã được chấp thuận bởi chính thức',
    stayOn: 'Ở lại trình độ A trong 7 ngày',
    over1k: 'Hơn 1 nghìn người hâm mộ',
    totalGifter: 'Tổng số người tặng quà > 300',
    receiveAll: 'Nhận tất cả quà tặng "May mắn"',
    everyLucky: 'Mỗi số quà tặng may mắn phải trên 100',
    stayOn2: 'Ở mức S trong 10 ngày',
    over2k: 'Hơn 2 nghìn người hâm mộ',
    totalGifter2: 'Tổng số người tặng quà> 300',
    receiveAll2: 'Nhận tất cả quà tặng "Hot"',
    stayOn3: 'Ở mức SS trong 10 ngày',
    over5k: 'Hơn 5 nghìn người hâm mộ',
    totalGifter3: 'Tổng số người tặng quà > 1000',
    receiveAll3: 'Nhận tất cả quà tặng "Sang trọng"',
    starHost6: 'Nhiệm vụ hàng ngày của Star Host',
    dailyAssessment: '(Hệ thống đánh giá hàng ngày): Tương tác / Quà tặng',
    gcionGifts: 'Quà tặng Gcion',
    rulesTo: 'Quy tắc để hạ cấp Cấp độ Chủ nhà Sao',
    failTo: 'Không đạt tiêu chuẩn của cấp độ hiện tại trong 3 ngày liên tiếp.',
    failingTo: 'Không đạt tiêu chuẩn <span>3 lần trong vòng một tuần',
    ifThe2: 'Nếu host không đạt yêu cầu hàng ngày ở cấp độ A, host sẽ bị sa thải trực tiếp thay vì bị giáng cấp. Sau khi bị giáng cấp, host phải đạt tiêu chuẩn cấp độ ban đầu trong 3 ngày liên tiếp để lấy lại cấp độ.',
    involvementIn: 'Có liên quan đến các hành vi vi phạm nghiêm trọng hoặc các sự cố tiêu cực.',
    causingDamage: 'Gây tổn hại đến lợi ích của nền tảng hoặc hình ảnh thương hiệu',
    applyFor: 'Tự nộp đơn xin nghỉ việc',
    liveStreaming: 'Yêu cầu phát trực tiếp',
    liveStream: 'Nội dung phát trực tiếp phải phù hợp với loại người được chỉ định của máy chủ',
    roomHosts: 'Người quản lý phòng không được phép tắt micrô trong thời gian dài trong quá trình phát sóng',
    liveStreams: 'Phát trực tiếp phải được thực hiện bằng cách sử dụng bố trí phòng micro 9 chỗ ngồi.',
    otherSeats: 'Những ghế khác trong phòng không được phép có người dùng hoặc khán giả tắt micrô để phục vụ mục đích phân công nhiệm vụ.',
    discriminatoryInsulting: 'Nghiêm cấm các nhận xét phân biệt đối xử, lăng mạ hoặc xúc phạm trong phòng'
  },
  starRoom: {
    afterCountdown: 'Sau khi đếm ngược mỗi ngày, Top3 phòng sẽ được liệt kê trong Xếp hạng phòng sao',
    top20Star: 'Top 20 phòng sao sẽ được thưởng tiền thưởng hậu hĩnh sau tuần này',
    countdown: 'Countdown：',
    top3Daily: 'Top 3 phòng top 3 hàng ngày sẽ đủ điều kiện tham gia phòng sao hàng tuần',
    starRooms: 'Phòng sao sẽ được xếp hạng vào ngày cuối cùng của tuần. Xếp hạng sẽ dựa trên tổng số xu lưu chuyển của mỗi phòng.',
    top20Weekly: 'Top 20 chủ phòng sao hàng tuần sẽ nhận được phần thưởng như sau',
    qualificationTo: 'Điều kiện tham gia sự kiện này: Mọi hành vi vi phạm hoặc hành vi bất hợp pháp đều không được phép trong phòng, một khi bị phát hiện, hala sẽ hủy tư cách tham gia và xóa phòng khỏi thứ hạng',
    theRewards: 'Phần thưởng sẽ được gửi vào mỗi thứ Hai.',
    days: 'days',
    coins: 'Coins'
  },
  inviteActive: {
    inviteHosts: 'Mời chủ nhà',
    pointsMax: 'Tối đa 5.000 điểm mỗi ngày',
    firstRecharge: 'Người dùng nạp tiền lần đầu',
    get20: 'Nhận 20 đô la miễn phí',
    oneInvite: '1. Mời người dẫn chương trình bắt đầu phát trực tiếp khi những người bạn mời hoàn tất.',
    aFinish: 'a. Hoàn tất xác minh khuôn mặt trên trung tâm tác vụ',
    bCreate: 'b. Tạo phòng riêng của cô ấy',
    cLive: 'c. Trực tiếp trên mic trong 3 giờ trong phòng của cô ấy',
    dClaim: 'd. Nhận phần thưởng trực tiếp lần đầu tiên',
    youGet: 'Bạn sẽ nhận được điểm thưởng mỗi ngày từ số điện thoại hợp lệ của người được mời. Bạn có thể nhận thưởng vào ngày hôm sau.',
    validHost: 'Máy chủ hợp lệ',
    pointsReward: 'Điểm thưởng',
    youCan: ' You can earn up to 5,000 invite points per day',
    myInvited: 'Chủ nhà được tôi mời',
    validHosts: 'Máy chủ hợp lệ hôm nay',
    pointsRewards: 'Điểm thưởng',
    validHosts2: 'Máy chủ hợp lệ hôm qua:',
    claim: 'Khẳng định',
    claimed: 'Đã yêu cầu',
    completedTime: 'Thời gian hoàn thành',
    ifYour: 'Nếu bạn bè của bạn hoàn thành lần nạp tiền đầu tiên, bạn sẽ nhận được rất nhiều phần thưởng. (Nạp tiền ngoại tuyến cũng sẽ được bao gồm).',
    theMore: 'Số tiền nạp đầu tiên càng cao thì bạn sẽ được thưởng càng nhiều xu và có thể lên tới 20 đô la mỗi ngày.',
    inviteesRecharge: 'Người được mời Nạp tiền xu',
    yourReward: 'Tiền thưởng của bạn',
    threeOnly: '3. Chỉ những người dùng được mời nạp tiền trong vòng 30 ngày mới được tính là người dùng nạp tiền đầu tiên hợp lệ.',
    seniorAnd: 'Người bán cao cấp và tiêu chuẩn sẽ chỉ được tính khi họ nạp tiền từ ứng dụng hoặc trực tiếp từ chính thức (liên hệ với quản trị viên để biết phương thức thanh toán) lần đầu tiên sẽ được tính là người dùng nạp tiền đầu tiên hợp lệ.',
    myInvited2: 'Người dùng được mời của tôi',
    rechargeCoins: 'Nạp tiền xu',
    coinsRewards: 'Phần thưởng tiền xu',
    firstRecharge2: 'Tiền nạp lần đầu Hôm qua:',
    firstRecharge3: 'Tiền xu nạp lần đầu',
    firstRecharge4: 'Thời gian nạp lần đầu'
  },
  hostPolicy: {
    title: 'Chính sách Host',
    section1Title: 'Lương Cơ Bản Tuần Đầu Cho Host Mới',
    requirement: 'Yêu cầu',
    newHostsDesc: 'Host mới gia nhập Hala trong tuần đầu tiên',
    activeTime: 'Thời Gian Hoạt Động Trên Mic',
    oneHour: '1 Giờ',
    twoHour: '2 Giờ',
    threeHour: '3 Giờ',
    baseSalary: 'Lương Cơ Bản (Điểm)',
    incomeRequirement: 'Yêu Cầu Thu Nhập',
    none: 'Không',
    remarks: 'Ghi chú',
    remarksDesc: 'Tối đa 3 giờ/ngày. Tối đa 7 ngày. Tổng thưởng tối đa 35.000 điểm',
    note1: 'Từ ngày đăng ký của host, thời hạn hiệu lực lương cơ bản 7 ngày bắt đầu đếm ngược.',
    note2: 'Host sử dụng nhiều tài khoản hoặc đăng nhập bằng nhiều IP hoặc thiết bị sẽ bị loại khỏi thưởng lương cơ bản.',
    note3: 'Nếu thu nhập 7 ngày gần nhất của host trên 150.000 điểm, cô ấy sẽ nhận được Thưởng Theo Giờ Host Thường thay vì Thưởng Lương Cơ Bản Host Mới.',
    section2Title: 'Thưởng Bình Đẳng Host Thường',
    level: 'Cấp độ',
    incomeRequirementShort: 'Yêu Cầu Thu Nhập',
    hourlyReward: 'Thưởng Theo Giờ',
    maximumDailyHours: 'Số Giờ Tối Đa Mỗi Ngày',
    section2Note1: '15 phút liên tục trên Mic sẽ được tính là thời gian hiệu quả.',
    section2Note2: 'Tất cả thưởng được thanh toán bằng điểm và cần được nhận trên hệ thống nhiệm vụ.',
    section2Note3: 'Thưởng nền tảng sẽ không được tính vào yêu cầu điểm.',
    section2Note4: 'Điểm sẽ bị trừ khi phát hiện nhiều IP hoặc thiết bị.',
    section2Note5: '7 ngày qua có nghĩa là 6 ngày qua+ngày hôm nay, do đó thưởng theo giờ của bạn có thể tăng khi bạn kịp thời đạt cấp độ điểm cao hơn.',
    section2Note6: 'Thưởng không mục tiêu cấp L chỉ có hiệu lực trong 7 ngày đầu sau khi đăng ký. Sau 7 ngày, host có thể nhận 500 điểm miễn phí mỗi ngày vĩnh viễn.',
    section3Title: 'Quy Định Host',
    regulation1: 'Host bị禁止 đăng ký nhiều tài khoản.',
    regulation2: 'Bị禁止 quảng bá các nền tảng bên thứ ba.',
    regulation3: 'Người dưới 18 tuổi bị禁止 nghiêm ngặt.',
    regulation4: 'Một host chỉ có thể có một ID đã xác minh. Chỉ ID đã xác minh mới có thể bắt đầu phát trực tiếp và rút thu nhập.',
    regulation5: 'Bất kỳ hành vi mạo danh xác thực khuôn mặt để bắt đầu phát trực tiếp hoặc rút thu nhập sẽ bị cấm vĩnh viễn.',
    regulation6: 'Cung cấp ID cho người khác để phát trực tiếp sẽ dẫn đến việc ID bị hệ thống cấm vĩnh viễn.',
    regulation7: 'Trong phòng thoại, host phải chủ động chào người dùng vào phòng.',
    regulation8: 'Ảnh bìa phòng thoại phải sử dụng ảnh thật, tuân thủ của host.',
    regulation9: 'Nền tảng Hala nghiêm cấm bất kỳ hành vi gian lận nào. Bất kỳ vi phạm nào sẽ dẫn đến đình chỉ tài khoản vĩnh viễn.',
    footer: 'Hala bảo lưu quyền giải thích cuối cùng của các chính sách trên.',
  },
  correspondingRevenue: 'các yêu cầu doanh thu tương ứng được đáp ứng. Tất cả phần thưởng sẽ được phát hành',
  within12: 'trong vòng 1-2 ngày làm việc sau khi sự kiện kết thúc'
}
